import {TableCell, TableRow} from '@mui/material';
import styles from './NewTable.module.scss';
import {useTranslation} from 'react-i18next';

const NoDataRow = () => {
    const {t} = useTranslation('common');

    return (
        <TableRow>
            <TableCell
                colSpan={12}
                className={styles.noDataText}
            >
                {t('noData')}
            </TableCell>
        </TableRow>
    );
};

export default NoDataRow;
